import * as schoolSearchActionTypes from './schoolSearchActionTypes';

export {
  schoolSearchActionTypes
};
